import { render, staticRenderFns } from "./AbfFilterChip.vue?vue&type=template&id=806f3564&scoped=true&"
import script from "./AbfFilterChip.vue?vue&type=script&lang=js&"
export * from "./AbfFilterChip.vue?vue&type=script&lang=js&"
import style0 from "./AbfFilterChip.vue?vue&type=style&index=0&id=806f3564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806f3564",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VChip,VIcon,VProgressCircular})
